













import { defineComponent, getCurrentInstance, ComponentInternalInstance } from '@vue/composition-api';
import { ChevronLeftIcon, SwapIcon } from 'tdesign-icons-vue';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import meetingHandler from '@/renderer/components/meeting/meetingHandler';
export default defineComponent({
  components: { ChevronLeftIcon, SwapIcon },
  setup() {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const route = vm.$route;
    const store = vm.$store;

    const { methods: meetingMethods } = meetingHandler();
    const methods = {
      back() {
        const routeName = store.getters.isLogined ? 'workbench' : 'login';
        dispatchRouter({ name: routeName });
      },
    };

    // 此处为客户端发起腾讯会议授权后，将重定向至该路由，由该路由再重定向至客户端的scheme，唤起客户端，进行相应操作
    if (route.name === 'meetingAuth' && route.query?.action !== '') {
      const { auth_code, meetingAction, from } = route.query;
      if (from === 'web') {
        meetingMethods.authMeeting(auth_code as string, meetingAction as string);
      } else {
        // 兼容老版本 默认认为是pc端打开
        dispatchRouter(`cofile://${window.location.href}`, 'location');
      }
    }

    return { ...methods };
  },
});
